/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
var icon_access_large_1 = require("./icons/icon_access-large");
var icon_access_1 = require("./icons/icon_access");
var icon_acdb_app_1 = require("./icons/icon_acdb-app");
var icon_acdb_large_1 = require("./icons/icon_acdb-large");
var icon_add_activity_small_1 = require("./icons/icon_add-activity-small");
var icon_add_activity_1 = require("./icons/icon_add-activity");
var icon_add_card_small_1 = require("./icons/icon_add-card-small");
var icon_add_small_1 = require("./icons/icon_add-small");
var icon_add_1 = require("./icons/icon_add");
var icon_admin_screen_large_1 = require("./icons/icon_admin-screen-large");
var icon_admin_screen_1 = require("./icons/icon_admin-screen");
var icon_advantages_1 = require("./icons/icon_advantages");
var icon_aircraft_take_off_1 = require("./icons/icon_aircraft-take-off");
var icon_alert_connection_lost_small_1 = require("./icons/icon_alert-connection-lost-small");
var icon_alert_error_small_1 = require("./icons/icon_alert-error-small");
var icon_alert_info_small_1 = require("./icons/icon_alert-info-small");
var icon_alert_success_small_1 = require("./icons/icon_alert-success-small");
var icon_alert_warning_small_1 = require("./icons/icon_alert-warning-small");
var icon_all_apps_1 = require("./icons/icon_all-apps");
var icon_api_1 = require("./icons/icon_api");
var icon_apps_group_1 = require("./icons/icon_apps-group");
var icon_apps_1 = require("./icons/icon_apps");
var icon_archive_1 = require("./icons/icon_archive");
var icon_arrow_down_1 = require("./icons/icon_arrow-down");
var icon_arrow_left_1 = require("./icons/icon_arrow-left");
var icon_arrow_right_1 = require("./icons/icon_arrow-right");
var icon_arrow_up_1 = require("./icons/icon_arrow-up");
var icon_articledatainflow_large_1 = require("./icons/icon_articledatainflow-large");
var icon_articledatainflow_1 = require("./icons/icon_articledatainflow");
var icon_assigned_portfolio_small_1 = require("./icons/icon_assigned-portfolio-small");
var icon_assigned_portfolio_1 = require("./icons/icon_assigned-portfolio");
var icon_back_1 = require("./icons/icon_back");
var icon_block_2_1 = require("./icons/icon_block-2");
var icon_blockquote_1 = require("./icons/icon_blockquote");
var icon_block_1 = require("./icons/icon_block");
var icon_bookable_services_1 = require("./icons/icon_bookable-services");
var icon_bottles_small_1 = require("./icons/icon_bottles-small");
var icon_bottles_1 = require("./icons/icon_bottles");
var icon_bowl_1 = require("./icons/icon_bowl");
var icon_brochures_1 = require("./icons/icon_brochures");
var icon_business_join_small_1 = require("./icons/icon_business-join-small");
var icon_business_join_1 = require("./icons/icon_business-join");
var icon_business_1 = require("./icons/icon_business");
var icon_calendar_1 = require("./icons/icon_calendar");
var icon_camera_1 = require("./icons/icon_camera");
var icon_cancel_1 = require("./icons/icon_cancel");
var icon_card_2_1 = require("./icons/icon_card-2");
var icon_cardholder_1 = require("./icons/icon_cardholder");
var icon_card_1 = require("./icons/icon_card");
var icon_cars_1 = require("./icons/icon_cars");
var icon_cc_small_1 = require("./icons/icon_cc-small");
var icon_cc_1 = require("./icons/icon_cc");
var icon_certificate_small_1 = require("./icons/icon_certificate-small");
var icon_certificate_1 = require("./icons/icon_certificate");
var icon_checkbox_1 = require("./icons/icon_checkbox");
var icon_check_large_1 = require("./icons/icon_check-large");
var icon_check_small_filled_1 = require("./icons/icon_check-small-filled");
var icon_check_small_1 = require("./icons/icon_check-small");
var icon_check_1 = require("./icons/icon_check");
var icon_chevron_down_small_1 = require("./icons/icon_chevron-down-small");
var icon_chevron_down_1 = require("./icons/icon_chevron-down");
var icon_chevron_left_small_1 = require("./icons/icon_chevron-left-small");
var icon_chevron_left_1 = require("./icons/icon_chevron-left");
var icon_chevron_right_1 = require("./icons/icon_chevron-right");
var icon_chevron_small_down_1 = require("./icons/icon_chevron-small-down");
var icon_chevron_right_small_1 = require("./icons/icon_chevron-right-small");
var icon_chevron_up_small_1 = require("./icons/icon_chevron-up-small");
var icon_chevron_up_1 = require("./icons/icon_chevron-up");
var icon_clock_1 = require("./icons/icon_clock");
var icon_close_small_1 = require("./icons/icon_close-small");
var icon_close_1 = require("./icons/icon_close");
var icon_cockpit_1 = require("./icons/icon_cockpit");
var icon_comment_add_1 = require("./icons/icon_comment-add");
var icon_comment_filled_1 = require("./icons/icon_comment-filled");
var icon_comment_1 = require("./icons/icon_comment");
var icon_company_1 = require("./icons/icon_company");
var icon_contact_1 = require("./icons/icon_contact");
var icon_contract_1 = require("./icons/icon_contract");
var icon_controller_record_1 = require("./icons/icon_controller-record");
var icon_cross_1 = require("./icons/icon_cross");
var icon_cutlery_1 = require("./icons/icon_cutlery");
var icon_delivery_1 = require("./icons/icon_delivery");
var icon_delivery_up_large_1 = require("./icons/icon_delivery-up-large");
var icon_dev_portal_placeholder_1 = require("./icons/icon_dev-portal-placeholder");
var icon_dialog_1 = require("./icons/icon_dialog");
var icon_direction_up_1 = require("./icons/icon_direction-up");
var icon_documents_large_1 = require("./icons/icon_documents-large");
var icon_documents_1 = require("./icons/icon_documents");
var icon_dot_single_1 = require("./icons/icon_dot-single");
var icon_dot_three_horizontal_1 = require("./icons/icon_dot-three-horizontal");
var icon_dot_three_vertical_1 = require("./icons/icon_dot-three-vertical");
var icon_download_activity_small_1 = require("./icons/icon_download-activity-small");
var icon_download_activity_1 = require("./icons/icon_download-activity");
var icon_download_1 = require("./icons/icon_download");
var icon_drag_drop_large_1 = require("./icons/icon_drag-drop-large");
var icon_drag_drop_1 = require("./icons/icon_drag-drop");
var icon_dropdown_1 = require("./icons/icon_dropdown");
var icon_eac_app_large_1 = require("./icons/icon_eac-app-large");
var icon_eac_app_1 = require("./icons/icon_eac-app");
var icon_edit_field_1 = require("./icons/icon_edit-field");
var icon_edit_small_1 = require("./icons/icon_edit-small");
var icon_edit_1 = require("./icons/icon_edit");
var icon_efinance_large_1 = require("./icons/icon_efinance-large");
var icon_efinance_1 = require("./icons/icon_efinance");
var icon_eform_large_1 = require("./icons/icon_eform-large");
var icon_email_edit_large_1 = require("./icons/icon_email-edit-large");
var icon_email_edit_1 = require("./icons/icon_email-edit");
var icon_enter_manually_1 = require("./icons/icon_enter-manually");
var icon_eq_app_large_1 = require("./icons/icon_eq-app-large");
var icon_eq_app_1 = require("./icons/icon_eq-app");
var icon_erase_1 = require("./icons/icon_erase");
var icon_error_large_1 = require("./icons/icon_error-large");
var icon_error_1 = require("./icons/icon_error");
var icon_external_link_1 = require("./icons/icon_external-link");
var icon_file_table_1 = require("./icons/icon_file-table");
var icon_filter_1 = require("./icons/icon_filter");
var icon_focus_large_1 = require("./icons/icon_focus-large");
var icon_focus_1 = require("./icons/icon_focus");
var icon_food_assortment_1 = require("./icons/icon_food-assortment");
var icon_gapcheck_app_large_1 = require("./icons/icon_gapcheck-app-large");
var icon_gapcheck_app_1 = require("./icons/icon_gapcheck-app");
var icon_gate_management_navi_large_1 = require("./icons/icon_gate-management-navi-large");
var icon_gate_management_navi_1 = require("./icons/icon_gate-management-navi");
var icon_globus_1 = require("./icons/icon_globus");
var icon_gps_1 = require("./icons/icon_gps");
var icon_graduation_cap_1 = require("./icons/icon_graduation-cap");
var icon_grid_1 = require("./icons/icon_grid");
var icon_group_1 = require("./icons/icon_group");
var icon_help_1 = require("./icons/icon_help");
var icon_hide_1 = require("./icons/icon_hide");
var icon_hierarchy_3_1 = require("./icons/icon_hierarchy-3");
var icon_house_1 = require("./icons/icon_house");
var icon_ica_large_1 = require("./icons/icon_ica-large");
var icon_ica_1 = require("./icons/icon_ica");
var icon_icr_large_1 = require("./icons/icon_icr-large");
var icon_icr_1 = require("./icons/icon_icr");
var icon_IDS_large_1 = require("./icons/icon_IDS-large");
var icon_IDS_1 = require("./icons/icon_IDS");
var icon_image_1 = require("./icons/icon_image");
var icon_indeterminate_small_1 = require("./icons/icon_indeterminate-small");
var icon_info_large_1 = require("./icons/icon_info-large");
var icon_info_small_1 = require("./icons/icon_info-small");
var icon_info_1 = require("./icons/icon_info");
var icon_inspiration_1 = require("./icons/icon_inspiration");
var icon_invoices_1 = require("./icons/icon_invoices");
var icon_keyboard_1 = require("./icons/icon_keyboard");
var icon_landline_1 = require("./icons/icon_landline");
var icon_launch_1 = require("./icons/icon_launch");
var icon_law_app_large_1 = require("./icons/icon_law-app-large");
var icon_law_app_1 = require("./icons/icon_law-app");
var icon_license_2_1 = require("./icons/icon_license-2");
var icon_license_1 = require("./icons/icon_license");
var icon_line_break_1 = require("./icons/icon_line-break");
var icon_lists_added_1 = require("./icons/icon_lists-added");
var icon_lists_add_1 = require("./icons/icon_lists-add");
var icon_lists_1 = require("./icons/icon_lists");
var icon_list_1 = require("./icons/icon_list");
var icon_location_filled_small_1 = require("./icons/icon_location-filled-small");
var icon_location_filled_1 = require("./icons/icon_location-filled");
var icon_location_large_1 = require("./icons/icon_location-large");
var icon_location_small_1 = require("./icons/icon_location-small");
var icon_location_1 = require("./icons/icon_location");
var icon_lock_1 = require("./icons/icon_lock");
var icon_logout_1 = require("./icons/icon_logout");
var icon_loyalty_filled_1 = require("./icons/icon_loyalty-filled");
var icon_loyalty_1 = require("./icons/icon_loyalty");
var icon_mail_small_1 = require("./icons/icon_mail-small");
var icon_mail_1 = require("./icons/icon_mail");
var icon_makro_1 = require("./icons/icon_makro");
var icon_male_filled_1 = require("./icons/icon_male-filled");
var icon_male_1 = require("./icons/icon_male");
var icon_map_large_1 = require("./icons/icon_map-large");
var icon_map_1 = require("./icons/icon_map");
var icon_mcat_large_1 = require("./icons/icon_mcat-large");
var icon_mcat_1 = require("./icons/icon_mcat");
var icon_MDW_large_1 = require("./icons/icon_MDW-large");
var icon_MDW_1 = require("./icons/icon_MDW");
var icon_mec_1 = require("./icons/icon_mec");
var icon_meetings_1 = require("./icons/icon_meetings");
var icon_menu_2_1 = require("./icons/icon_menu-2");
var icon_menu_search_1 = require("./icons/icon_menu-search");
var icon_menu_1 = require("./icons/icon_menu");
var icon_messaging_1 = require("./icons/icon_messaging");
var icon_metro_small_1 = require("./icons/icon_metro-small");
var icon_metro_1 = require("./icons/icon_metro");
var icon_mintec_app_large_1 = require("./icons/icon_mintec-app-large");
var icon_mintec_app_1 = require("./icons/icon_mintec-app");
var icon_minus_1 = require("./icons/icon_minus");
var icon_monitoring_1 = require("./icons/icon_monitoring");
var icon_more_1 = require("./icons/icon_more");
var icon_movie_app_large_1 = require("./icons/icon_movie-app-large");
var icon_movie_app_1 = require("./icons/icon_movie-app");
var icon_msp_app_large_1 = require("./icons/icon_msp-app-large");
var icon_msp_app_1 = require("./icons/icon_msp-app");
var icon_mssi_large_1 = require("./icons/icon_mssi-large");
var icon_multi_line_input_1 = require("./icons/icon_multi-line-input");
var icon_multiple_choice_1 = require("./icons/icon_multiple-choice");
var icon_my_apps_1 = require("./icons/icon_my-apps");
var icon_navigation_arrow_large_1 = require("./icons/icon_navigation-arrow-large");
var icon_navigation_arrow_1 = require("./icons/icon_navigation-arrow");
var icon_navigation_large_1 = require("./icons/icon_navigation-large");
var icon_navigation_1 = require("./icons/icon_navigation");
var icon_new_message_1 = require("./icons/icon_new-message");
var icon_newsletter_1 = require("./icons/icon_newsletter");
var icon_news_1 = require("./icons/icon_news");
var icon_new_1 = require("./icons/icon_new");
var icon_nonfood_assortment_1 = require("./icons/icon_nonfood-assortment");
var icon_notification_1 = require("./icons/icon_notification");
var icon_nsp_app_large_1 = require("./icons/icon_nsp-app-large");
var icon_nsp_app_1 = require("./icons/icon_nsp-app");
var icon_orderhistory_1 = require("./icons/icon_orderhistory");
var icon_orders_1 = require("./icons/icon_orders");
var icon_paragraph_1 = require("./icons/icon_paragraph");
var icon_payments_1 = require("./icons/icon_payments");
var icon_percent_small_1 = require("./icons/icon_percent-small");
var icon_permission_1 = require("./icons/icon_permission");
var icon_phoenix_apps_large_1 = require("./icons/icon_phoenix-apps-large");
var icon_phoenix_apps_1 = require("./icons/icon_phoenix-apps");
var icon_phone_1 = require("./icons/icon_phone");
var icon_play_1 = require("./icons/icon_play");
var icon_plus_1 = require("./icons/icon_plus");
var icon_ppm_1 = require("./icons/icon_ppm");
var icon_print_document_1 = require("./icons/icon_print-document");
var icon_print_1 = require("./icons/icon_print");
var icon_profile_large_1 = require("./icons/icon_profile-large");
var icon_profile_1 = require("./icons/icon_profile");
var icon_promotion_large_1 = require("./icons/icon_promotion-large");
var icon_promotion_1 = require("./icons/icon_promotion");
var icon_rating_filled_1 = require("./icons/icon_rating-filled");
var icon_rating_line_1 = require("./icons/icon_rating-line");
var icon_rating_small_1 = require("./icons/icon_rating-small");
var icon_recipes_1 = require("./icons/icon_recipes");
var icon_recycling_1 = require("./icons/icon_recycling");
var icon_register_apps_1 = require("./icons/icon_register-apps");
var icon_rejected_small_1 = require("./icons/icon_rejected-small");
var icon_reload_1 = require("./icons/icon_reload");
var icon_reminder_1 = require("./icons/icon_reminder");
var icon_remove_1 = require("./icons/icon_remove");
var icon_replace_1 = require("./icons/icon_replace");
var icon_request_1 = require("./icons/icon_request");
var icon_returns_1 = require("./icons/icon_returns");
var icon_sale_1 = require("./icons/icon_sale");
var icon_save_1 = require("./icons/icon_save");
var icon_scanner_1 = require("./icons/icon_scanner");
var icon_scot_large_1 = require("./icons/icon_scot-large");
var icon_scot_1 = require("./icons/icon_scot");
var icon_search_1 = require("./icons/icon_search");
var icon_security_1 = require("./icons/icon_security");
var icon_select_1 = require("./icons/icon_select");
var icon_settings_1 = require("./icons/icon_settings");
var icon_share_1 = require("./icons/icon_share");
var icon_shop_large_1 = require("./icons/icon_shop-large");
var icon_shopping_cart_1 = require("./icons/icon_shopping-cart");
var icon_shop_1 = require("./icons/icon_shop");
var icon_show_1 = require("./icons/icon_show");
var icon_sidebar_decrease_1 = require("./icons/icon_sidebar-decrease");
var icon_sidebar_expand_1 = require("./icons/icon_sidebar-expand");
var icon_social_facebook_1 = require("./icons/icon_social-facebook");
var icon_social_google_1 = require("./icons/icon_social-google");
var icon_social_instagram_1 = require("./icons/icon_social-instagram");
var icon_social_metro_blog_1 = require("./icons/icon_social-metro-blog");
var icon_social_odnoklassniki_1 = require("./icons/icon_social-odnoklassniki");
var icon_social_pinterest_1 = require("./icons/icon_social-pinterest");
var icon_social_twitter_1 = require("./icons/icon_social-twitter");
var icon_social_vk_1 = require("./icons/icon_social-vk");
var icon_social_youtube_1 = require("./icons/icon_social-youtube");
var icon_sort_1 = require("./icons/icon_sort");
var icon_sort_up_1 = require("./icons/icon_sort-up");
var icon_store_makro_1 = require("./icons/icon_store-makro");
var icon_store_metro_1 = require("./icons/icon_store-metro");
var icon_store_small_1 = require("./icons/icon_store-small");
var icon_swap_business_small_1 = require("./icons/icon_swap-business-small");
var icon_swap_business_1 = require("./icons/icon_swap-business");
var icon_sync_1 = require("./icons/icon_sync");
var icon_tag_small_1 = require("./icons/icon_tag-small");
var icon_tags_1 = require("./icons/icon_tags");
var icon_tag_1 = require("./icons/icon_tag");
var icon_text_1 = require("./icons/icon_text");
var icon_thumbs_up_large_1 = require("./icons/icon_thumbs-up-large");
var icon_thumbs_up_1 = require("./icons/icon_thumbs-up");
var icon_thunder_cloud_1 = require("./icons/icon_thunder-cloud");
var icon_timer_1 = require("./icons/icon_timer");
var icon_time_slot_1 = require("./icons/icon_time-slot");
var icon_tooltip_pin_bottom_1 = require("./icons/icon_tooltip-pin-bottom");
var icon_tooltip_pin_left_1 = require("./icons/icon_tooltip-pin-left");
var icon_tooltip_pin_right_1 = require("./icons/icon_tooltip-pin-right");
var icon_tooltip_pin_top_1 = require("./icons/icon_tooltip-pin-top");
var icon_translator_large_1 = require("./icons/icon_translator-large");
var icon_translator_1 = require("./icons/icon_translator");
var icon_trash_1 = require("./icons/icon_trash");
var icon_truck_large_1 = require("./icons/icon_truck-large");
var icon_truck_small_1 = require("./icons/icon_truck-small");
var icon_truck_1 = require("./icons/icon_truck");
var icon_unassigned_portfolio_small_1 = require("./icons/icon_unassigned-portfolio-small");
var icon_unassigned_portfolio_1 = require("./icons/icon_unassigned-portfolio");
var icon_unlock_1 = require("./icons/icon_unlock");
var icon_upload_large_1 = require("./icons/icon_upload-large");
var icon_upload_1 = require("./icons/icon_upload");
var icon_user_add_1 = require("./icons/icon_user-add");
var icon_user_chat_group_1 = require("./icons/icon_user-chat-group");
var icon_flag_triangle_2_filled_1 = require("./icons/icon_flag-triangle-2-filled");
var icon_flag_triangle_2_1 = require("./icons/icon_flag-triangle-2");
var icon_user_permissions_preset_1 = require("./icons/icon_user-permissions-preset");
var icon_user_permissions_1 = require("./icons/icon_user-permissions");
var icon_user_remove_1 = require("./icons/icon_user-remove");
var icon_user_small_1 = require("./icons/icon_user-small");
var icon_user_1 = require("./icons/icon_user");
var icon_user_warning_1 = require("./icons/icon_user-warning");
var icon_uxhub_app_large_1 = require("./icons/icon_uxhub-app-large");
var icon_video_camera_1 = require("./icons/icon_video-camera");
var icon_warning_filled_1 = require("./icons/icon_warning-filled");
var icon_warning_small_filled_1 = require("./icons/icon_warning-small-filled");
var icon_warning_1 = require("./icons/icon_warning");
var icon_yard_gate_large_1 = require("./icons/icon_yard-gate-large");
var icon_yard_gate_1 = require("./icons/icon_yard-gate");
var icon_yard_outzone_large_1 = require("./icons/icon_yard-outzone-large");
var icon_yard_outzone_single_large_1 = require("./icons/icon_yard-outzone-single-large");
var icon_yard_outzone_single_1 = require("./icons/icon_yard-outzone-single");
var icon_yard_outzone_1 = require("./icons/icon_yard-outzone");
var icon_zoom_1 = require("./icons/icon_zoom");
var icon_user_activated_1 = require("./icons/icon_user-activated");
var icon_user_deactivated_1 = require("./icons/icon_user-deactivated");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Icon.css'); }
var TypesMap = {
    access: icon_access_1.IconSVG,
    "access-large": icon_access_large_1.IconSVG,
    "acdb-app": icon_acdb_app_1.IconSVG,
    "acdb-large": icon_acdb_large_1.IconSVG,
    add: icon_add_1.IconSVG,
    "add-activity-small": icon_add_activity_small_1.IconSVG,
    "add-activity": icon_add_activity_1.IconSVG,
    "add-card-small": icon_add_card_small_1.IconSVG,
    "add-small": icon_add_small_1.IconSVG,
    "admin-screen-large": icon_admin_screen_large_1.IconSVG,
    "admin-screen": icon_admin_screen_1.IconSVG,
    advantages: icon_advantages_1.IconSVG,
    "aircraft-take-off": icon_aircraft_take_off_1.IconSVG,
    "alert-connection-lost-small": icon_alert_connection_lost_small_1.IconSVG,
    "alert-error-small": icon_alert_error_small_1.IconSVG,
    "alert-info-small": icon_alert_info_small_1.IconSVG,
    "alert-success-small": icon_alert_success_small_1.IconSVG,
    "alert-warning-small": icon_alert_warning_small_1.IconSVG,
    "all-apps": icon_all_apps_1.IconSVG,
    api: icon_api_1.IconSVG,
    apps: icon_apps_1.IconSVG,
    "apps-group": icon_apps_group_1.IconSVG,
    archive: icon_archive_1.IconSVG,
    "arrow-down": icon_arrow_down_1.IconSVG,
    "arrow-left": icon_arrow_left_1.IconSVG,
    "arrow-right": icon_arrow_right_1.IconSVG,
    "arrow-up": icon_arrow_up_1.IconSVG,
    "articledatainflow-large": icon_articledatainflow_large_1.IconSVG,
    articledatainflow: icon_articledatainflow_1.IconSVG,
    "assigned-portfolio-small": icon_assigned_portfolio_small_1.IconSVG,
    "assigned-portfolio": icon_assigned_portfolio_1.IconSVG,
    back: icon_back_1.IconSVG,
    block: icon_block_1.IconSVG,
    "block-2": icon_block_2_1.IconSVG,
    blockquote: icon_blockquote_1.IconSVG,
    "bookable-services": icon_bookable_services_1.IconSVG,
    bottles: icon_bottles_1.IconSVG,
    "bottles-small": icon_bottles_small_1.IconSVG,
    bowl: icon_bowl_1.IconSVG,
    brochures: icon_brochures_1.IconSVG,
    business: icon_business_1.IconSVG,
    "business-join-small": icon_business_join_small_1.IconSVG,
    "business-join": icon_business_join_1.IconSVG,
    calendar: icon_calendar_1.IconSVG,
    camera: icon_camera_1.IconSVG,
    cancel: icon_cancel_1.IconSVG,
    card: icon_card_1.IconSVG,
    "card-2": icon_card_2_1.IconSVG,
    cardholder: icon_cardholder_1.IconSVG,
    cars: icon_cars_1.IconSVG,
    cc: icon_cc_1.IconSVG,
    "cc-small": icon_cc_small_1.IconSVG,
    certificate: icon_certificate_1.IconSVG,
    "certificate-small": icon_certificate_small_1.IconSVG,
    check: icon_check_1.IconSVG,
    checkbox: icon_checkbox_1.IconSVG,
    "check-large": icon_check_large_1.IconSVG,
    "check-small-filled": icon_check_small_filled_1.IconSVG,
    "check-small": icon_check_small_1.IconSVG,
    "chevron-down-small": icon_chevron_down_small_1.IconSVG,
    "chevron-down": icon_chevron_down_1.IconSVG,
    "chevron-left-small": icon_chevron_left_small_1.IconSVG,
    "chevron-left": icon_chevron_left_1.IconSVG,
    "chevron-right-small": icon_chevron_right_small_1.IconSVG,
    "chevron-right": icon_chevron_right_1.IconSVG,
    "chevron-small-down": icon_chevron_small_down_1.IconSVG,
    "chevron-up-small": icon_chevron_up_small_1.IconSVG,
    "chevron-up": icon_chevron_up_1.IconSVG,
    clock: icon_clock_1.IconSVG,
    close: icon_close_1.IconSVG,
    "close-small": icon_close_small_1.IconSVG,
    cockpit: icon_cockpit_1.IconSVG,
    comment: icon_comment_1.IconSVG,
    "comment-add": icon_comment_add_1.IconSVG,
    "comment-filled": icon_comment_filled_1.IconSVG,
    company: icon_company_1.IconSVG,
    contact: icon_contact_1.IconSVG,
    contract: icon_contract_1.IconSVG,
    "controller-record": icon_controller_record_1.IconSVG,
    cross: icon_cross_1.IconSVG,
    cutlery: icon_cutlery_1.IconSVG,
    delivery: icon_delivery_1.IconSVG,
    "delivery-up-large": icon_delivery_up_large_1.IconSVG,
    "dev-portal-placeholder": icon_dev_portal_placeholder_1.IconSVG,
    dialog: icon_dialog_1.IconSVG,
    "direction-up": icon_direction_up_1.IconSVG,
    documents: icon_documents_1.IconSVG,
    "documents-large": icon_documents_large_1.IconSVG,
    "dot-single": icon_dot_single_1.IconSVG,
    "dot-three-horizontal": icon_dot_three_horizontal_1.IconSVG,
    "dot-three-vertical": icon_dot_three_vertical_1.IconSVG,
    download: icon_download_1.IconSVG,
    "download-activity-small": icon_download_activity_small_1.IconSVG,
    "download-activity": icon_download_activity_1.IconSVG,
    "drag-drop-large": icon_drag_drop_large_1.IconSVG,
    "drag-drop": icon_drag_drop_1.IconSVG,
    dropdown: icon_dropdown_1.IconSVG,
    "eac-app-large": icon_eac_app_large_1.IconSVG,
    "eac-app": icon_eac_app_1.IconSVG,
    edit: icon_edit_1.IconSVG,
    "edit-field": icon_edit_field_1.IconSVG,
    "edit-small": icon_edit_small_1.IconSVG,
    efinance: icon_efinance_1.IconSVG,
    "efinance-large": icon_efinance_large_1.IconSVG,
    "eform-large": icon_eform_large_1.IconSVG,
    "email-edit-large": icon_email_edit_large_1.IconSVG,
    "email-edit": icon_email_edit_1.IconSVG,
    "enter-manually": icon_enter_manually_1.IconSVG,
    "eq-app-large": icon_eq_app_large_1.IconSVG,
    "eq-app": icon_eq_app_1.IconSVG,
    erase: icon_erase_1.IconSVG,
    error: icon_error_1.IconSVG,
    "error-large": icon_error_large_1.IconSVG,
    "external-link": icon_external_link_1.IconSVG,
    "file-table": icon_file_table_1.IconSVG,
    filter: icon_filter_1.IconSVG,
    "flag-triangle-2-filled": icon_flag_triangle_2_filled_1.IconSVG,
    "flag-triangle-2": icon_flag_triangle_2_1.IconSVG,
    focus: icon_focus_1.IconSVG,
    "focus-large": icon_focus_large_1.IconSVG,
    "food-assortment": icon_food_assortment_1.IconSVG,
    "gapcheck-app-large": icon_gapcheck_app_large_1.IconSVG,
    "gapcheck-app": icon_gapcheck_app_1.IconSVG,
    "gate-management-navi-large": icon_gate_management_navi_large_1.IconSVG,
    "gate-management-navi": icon_gate_management_navi_1.IconSVG,
    globus: icon_globus_1.IconSVG,
    gps: icon_gps_1.IconSVG,
    "graduation-cap": icon_graduation_cap_1.IconSVG,
    grid: icon_grid_1.IconSVG,
    group: icon_group_1.IconSVG,
    help: icon_help_1.IconSVG,
    hide: icon_hide_1.IconSVG,
    "hierarchy-3": icon_hierarchy_3_1.IconSVG,
    house: icon_house_1.IconSVG,
    ica: icon_ica_1.IconSVG,
    "ica-large": icon_ica_large_1.IconSVG,
    icr: icon_icr_1.IconSVG,
    "icr-large": icon_icr_large_1.IconSVG,
    IDS: icon_IDS_1.IconSVG,
    "IDS-large": icon_IDS_large_1.IconSVG,
    image: icon_image_1.IconSVG,
    "indeterminate-small": icon_indeterminate_small_1.IconSVG,
    info: icon_info_1.IconSVG,
    "info-large": icon_info_large_1.IconSVG,
    "info-small": icon_info_small_1.IconSVG,
    inspiration: icon_inspiration_1.IconSVG,
    invoices: icon_invoices_1.IconSVG,
    keyboard: icon_keyboard_1.IconSVG,
    landline: icon_landline_1.IconSVG,
    launch: icon_launch_1.IconSVG,
    "law-app-large": icon_law_app_large_1.IconSVG,
    "law-app": icon_law_app_1.IconSVG,
    license: icon_license_1.IconSVG,
    "license-2": icon_license_2_1.IconSVG,
    "line-break": icon_line_break_1.IconSVG,
    list: icon_list_1.IconSVG,
    lists: icon_lists_1.IconSVG,
    "lists-add": icon_lists_add_1.IconSVG,
    "lists-added": icon_lists_added_1.IconSVG,
    location: icon_location_1.IconSVG,
    "location-filled-small": icon_location_filled_small_1.IconSVG,
    "location-filled": icon_location_filled_1.IconSVG,
    "location-large": icon_location_large_1.IconSVG,
    "location-small": icon_location_small_1.IconSVG,
    lock: icon_lock_1.IconSVG,
    logout: icon_logout_1.IconSVG,
    loyalty: icon_loyalty_1.IconSVG,
    "loyalty-filled": icon_loyalty_filled_1.IconSVG,
    makro: icon_makro_1.IconSVG,
    mail: icon_mail_1.IconSVG,
    "mail-small": icon_mail_small_1.IconSVG,
    male: icon_male_1.IconSVG,
    "male-filled": icon_male_filled_1.IconSVG,
    map: icon_map_1.IconSVG,
    "map-large": icon_map_large_1.IconSVG,
    mcat: icon_mcat_1.IconSVG,
    "mcat-large": icon_mcat_large_1.IconSVG,
    MDW: icon_MDW_1.IconSVG,
    "MDW-large": icon_MDW_large_1.IconSVG,
    mec: icon_mec_1.IconSVG,
    meetings: icon_meetings_1.IconSVG,
    menu: icon_menu_1.IconSVG,
    "menu-2": icon_menu_2_1.IconSVG,
    "menu-search": icon_menu_search_1.IconSVG,
    messaging: icon_messaging_1.IconSVG,
    metro: icon_metro_1.IconSVG,
    "metro-small": icon_metro_small_1.IconSVG,
    "mintec-app-large": icon_mintec_app_large_1.IconSVG,
    "mintec-app": icon_mintec_app_1.IconSVG,
    minus: icon_minus_1.IconSVG,
    monitoring: icon_monitoring_1.IconSVG,
    more: icon_more_1.IconSVG,
    "movie-app-large": icon_movie_app_large_1.IconSVG,
    "movie-app": icon_movie_app_1.IconSVG,
    "msp-app-large": icon_msp_app_large_1.IconSVG,
    "msp-app": icon_msp_app_1.IconSVG,
    "mssi-large": icon_mssi_large_1.IconSVG,
    "multi-line-input": icon_multi_line_input_1.IconSVG,
    "multiple-choice": icon_multiple_choice_1.IconSVG,
    "my-apps": icon_my_apps_1.IconSVG,
    navigation: icon_navigation_1.IconSVG,
    "navigation-arrow-large": icon_navigation_arrow_large_1.IconSVG,
    "navigation-arrow": icon_navigation_arrow_1.IconSVG,
    "navigation-large": icon_navigation_large_1.IconSVG,
    new: icon_new_1.IconSVG,
    "new-message": icon_new_message_1.IconSVG,
    news: icon_news_1.IconSVG,
    newsletter: icon_newsletter_1.IconSVG,
    "nonfood-assortment": icon_nonfood_assortment_1.IconSVG,
    notification: icon_notification_1.IconSVG,
    "nsp-app-large": icon_nsp_app_large_1.IconSVG,
    "nsp-app": icon_nsp_app_1.IconSVG,
    orderhistory: icon_orderhistory_1.IconSVG,
    orders: icon_orders_1.IconSVG,
    paragraph: icon_paragraph_1.IconSVG,
    payments: icon_payments_1.IconSVG,
    "percent-small": icon_percent_small_1.IconSVG,
    permission: icon_permission_1.IconSVG,
    "phoenix-apps-large": icon_phoenix_apps_large_1.IconSVG,
    "phoenix-apps": icon_phoenix_apps_1.IconSVG,
    phone: icon_phone_1.IconSVG,
    play: icon_play_1.IconSVG,
    plus: icon_plus_1.IconSVG,
    ppm: icon_ppm_1.IconSVG,
    print: icon_print_1.IconSVG,
    "print-document": icon_print_document_1.IconSVG,
    profile: icon_profile_1.IconSVG,
    "profile-large": icon_profile_large_1.IconSVG,
    promotion: icon_promotion_1.IconSVG,
    "promotion-large": icon_promotion_large_1.IconSVG,
    "rating-filled": icon_rating_filled_1.IconSVG,
    "rating-line": icon_rating_line_1.IconSVG,
    "rating-small": icon_rating_small_1.IconSVG,
    recipes: icon_recipes_1.IconSVG,
    recycling: icon_recycling_1.IconSVG,
    "register-apps": icon_register_apps_1.IconSVG,
    "rejected-small": icon_rejected_small_1.IconSVG,
    reload: icon_reload_1.IconSVG,
    reminder: icon_reminder_1.IconSVG,
    remove: icon_remove_1.IconSVG,
    replace: icon_replace_1.IconSVG,
    request: icon_request_1.IconSVG,
    returns: icon_returns_1.IconSVG,
    sale: icon_sale_1.IconSVG,
    save: icon_save_1.IconSVG,
    scanner: icon_scanner_1.IconSVG,
    scot: icon_scot_1.IconSVG,
    "scot-large": icon_scot_large_1.IconSVG,
    search: icon_search_1.IconSVG,
    security: icon_security_1.IconSVG,
    select: icon_select_1.IconSVG,
    settings: icon_settings_1.IconSVG,
    share: icon_share_1.IconSVG,
    shop: icon_shop_1.IconSVG,
    "shop-large": icon_shop_large_1.IconSVG,
    "shopping-cart": icon_shopping_cart_1.IconSVG,
    show: icon_show_1.IconSVG,
    "sidebar-decrease": icon_sidebar_decrease_1.IconSVG,
    "sidebar-expand": icon_sidebar_expand_1.IconSVG,
    "social-facebook": icon_social_facebook_1.IconSVG,
    "social-google": icon_social_google_1.IconSVG,
    "social-instagram": icon_social_instagram_1.IconSVG,
    "social-metro-blog": icon_social_metro_blog_1.IconSVG,
    "social-odnoklassniki": icon_social_odnoklassniki_1.IconSVG,
    "social-pinterest": icon_social_pinterest_1.IconSVG,
    "social-twitter": icon_social_twitter_1.IconSVG,
    "social-vk": icon_social_vk_1.IconSVG,
    "social-youtube": icon_social_youtube_1.IconSVG,
    sort: icon_sort_1.IconSVG,
    "sort-up": icon_sort_up_1.IconSVG,
    "store-makro": icon_store_makro_1.IconSVG,
    "store-metro": icon_store_metro_1.IconSVG,
    "store-small": icon_store_small_1.IconSVG,
    "swap-business-small": icon_swap_business_small_1.IconSVG,
    "swap-business": icon_swap_business_1.IconSVG,
    sync: icon_sync_1.IconSVG,
    tag: icon_tag_1.IconSVG,
    "tag-small": icon_tag_small_1.IconSVG,
    tags: icon_tags_1.IconSVG,
    text: icon_text_1.IconSVG,
    "thumbs-up-large": icon_thumbs_up_large_1.IconSVG,
    "thumbs-up": icon_thumbs_up_1.IconSVG,
    "thunder-cloud": icon_thunder_cloud_1.IconSVG,
    timer: icon_timer_1.IconSVG,
    "time-slot": icon_time_slot_1.IconSVG,
    "tooltip-pin-bottom": icon_tooltip_pin_bottom_1.IconSVG,
    "tooltip-pin-left": icon_tooltip_pin_left_1.IconSVG,
    "tooltip-pin-right": icon_tooltip_pin_right_1.IconSVG,
    "tooltip-pin-top": icon_tooltip_pin_top_1.IconSVG,
    translator: icon_translator_1.IconSVG,
    "translator-large": icon_translator_large_1.IconSVG,
    trash: icon_trash_1.IconSVG,
    truck: icon_truck_1.IconSVG,
    "truck-large": icon_truck_large_1.IconSVG,
    "truck-small": icon_truck_small_1.IconSVG,
    "unassigned-portfolio-small": icon_unassigned_portfolio_small_1.IconSVG,
    "unassigned-portfolio": icon_unassigned_portfolio_1.IconSVG,
    unlock: icon_unlock_1.IconSVG,
    upload: icon_upload_1.IconSVG,
    "upload-large": icon_upload_large_1.IconSVG,
    user: icon_user_1.IconSVG,
    "user-activated": icon_user_activated_1.IconSVG,
    "user-add": icon_user_add_1.IconSVG,
    "user-chat-group": icon_user_chat_group_1.IconSVG,
    "user-deactivated": icon_user_deactivated_1.IconSVG,
    "user-permissions-preset": icon_user_permissions_preset_1.IconSVG,
    "user-permissions": icon_user_permissions_1.IconSVG,
    "user-remove": icon_user_remove_1.IconSVG,
    "user-small": icon_user_small_1.IconSVG,
    "user-warning": icon_user_warning_1.IconSVG,
    "uxhub-app-large": icon_uxhub_app_large_1.IconSVG,
    "video-camera": icon_video_camera_1.IconSVG,
    warning: icon_warning_1.IconSVG,
    "warning-filled": icon_warning_filled_1.IconSVG,
    "warning-small-filled": icon_warning_small_filled_1.IconSVG,
    "yard-gate": icon_yard_gate_1.IconSVG,
    "yard-gate-large": icon_yard_gate_large_1.IconSVG,
    "yard-outzone-large": icon_yard_outzone_large_1.IconSVG,
    "yard-outzone-single": icon_yard_outzone_single_1.IconSVG,
    "yard-outzone-single-large": icon_yard_outzone_single_large_1.IconSVG,
    "yard-outzone": icon_yard_outzone_1.IconSVG,
    zoom: icon_zoom_1.IconSVG
};
exports.IconTypesArray = Object.keys(TypesMap);
exports.IconAnimateArray = ["none", "rotate"];
exports.IconColorsArray = [
    "metro-blue",
    "metro-yellow",
    "blue",
    "green",
    "red",
    "grey",
    "white",
    "black",
    "metro-blue-tint-95",
    "metro-blue-tint-90",
    "metro-blue-tint-80",
    "metro-blue-tint-60",
    "metro-blue-tint-40",
    "metro-blue-tint-20",
    "blue-tint-95",
    "blue-tint-90",
    "blue-tint-80",
    "blue-tint-60",
    "blue-tint-40",
    "blue-tint-20",
    "blue-shade-40",
    "blue-shade-20",
    "green-tint-95",
    "green-tint-90",
    "green-tint-80",
    "green-tint-60",
    "green-tint-40",
    "green-tint-20",
    "red-tint-95",
    "red-tint-90",
    "red-tint-80",
    "red-tint-60",
    "red-tint-40",
    "red-tint-20",
    "red-shade-40",
    "red-shade-20",
    "grey-tint-95",
    "grey-tint-90",
    "grey-tint-80",
    "grey-tint-60",
    "grey-tint-40",
    "grey-tint-20"
];
exports.Icon = function Icon(_a) {
    var _b = _a.animate, animate = _b === void 0 ? "none" : _b, type = _a.type, className = _a.className, color = _a.color, size = _a.size;
    var props = {
        className: classnames([
            "m-icon",
            className,
            color,
            animate !== "none" && propertyToMCSSstate_1.propertyToMCSSstate("m-icon", animate)
        ]),
        style: size ? { fontSize: size + "rem" } : undefined,
        "aria-hidden": "true",
        role: "img",
        focusable: "false"
    };
    var IconSvg = TypesMap[type];
    if (!IconSvg) {
        return null;
    }
    return React.createElement(IconSvg, tslib_1.__assign({}, props));
};